import React, {Component} from 'react'

import {
    Calendar,
    Badge,
    Switch,
    Row,
    List,
    Typography,
    Avatar,
    Tooltip,
    Modal,
    Button,
    message,
    Spin
} from 'antd';
import { groupByDate, showErrorInNotification } from '../../lib/util';
import moment from 'moment';
import { PopUpForm } from '../../lib/ui/popupform';
import { withDomains, RESTExecutor } from '../../lib/domain';
import ModalTransactionDetail from '../../components/modal_transaction_detail';
import { BasicHeader } from '../../components/basic_header';
import { dashboard_quick_menu } from '../../util/ui_util';
import ErrorWrapper from '../../lib/error_wrapper';



const {Title}=Typography;

const todo_field=[
    {
        name: 'Date',
        index: 'date',
        type: 'date',
    },
    {
        name: 'Task',
        index: 'task',
        type: 'text',
    },
    {
        name: 'Description',
        index: 'description',
        type: 'textarea',
    },
]







class AllPending extends Component {
    constructor(props) {
        super(props)

        this.state = {
            viewType: 'calendar',
            pending_list:[],
            pending_obj:{},
            pending_todo_obj:{},
            dateQuery:{
                month:moment().get('month'),
                year:moment().get('year')
            },

            popup_detail_modal:false,
            current_selected_data:{}

        };

        this.list_todos=RESTExecutor.list().config({
            label:'todo'
        }).callbacks((success)=>{
            let rows=JSON.parse(JSON.stringify(success.result.rows||[]));
            rows.map((item)=>{
                item['type']='todo'
            })
            this.setState({
                pending_todo_obj:groupByDate({
                    list_data:rows
                })
            })
        },(error)=>{}).connect(props.domains.myTask);

        this.post_todos=RESTExecutor.post().config({
            label:'todo'
        }).callbacks((success)=>{
            this.list_todos.execute()
            this.setState({
                modal_open: false,
                form_data:{} 
            })
        },(error)=>{}).connect(props.domains.myTask);

        this.delete_todos=RESTExecutor.delete().config({
            label:'todo_detail'
        }).callbacks((success)=>{
            message.success("Deleted Todo");
            Modal.destroyAll();
            this.list_todos.execute();
        },(error)=>{
            showErrorInNotification(error)
            // message.error("Failed to delete. Please try again")
        }).connect(props.domains.myTask);

        this.mark_done_todo=RESTExecutor.patch().config({
            label:'todo_done'
        }).callbacks((success)=>{
            message.success("Maked done");
            this.list_todos.execute()
            Modal.destroyAll();
        },(error)=>{
            showErrorInNotification(error)
            // message.error("Failed to mark done")

        }).connect(props.domains.myTask);

        this.mark_done_followups=RESTExecutor.patch().config({
            label:'followups_done'
        }).callbacks((success)=>{
            message.success("Maked done");
            this.list_followups.execute()
            Modal.destroyAll();
        },(error)=>{
            showErrorInNotification(error)

            // message.error("Failed to mark done")

        }).connect(props.domains.myTask);

        this.list_followups=RESTExecutor.list().config({
            label:'followups'
        }).callbacks((success)=>{
            let rows=JSON.parse(JSON.stringify(success.result.rows||[]));
            let selected_data=this.state.current_selected_data;

            rows.map((item)=>{
                if(selected_data&&selected_data.id&&(selected_data.id==item.id)){
                    this.setState({current_selected_data:item})
                }
                item['type']='followup'
            })
            this.setState({
                pending_obj:groupByDate({
                    list_data:rows
                })
            })
        },(error)=>{

            showErrorInNotification(error);

        }).connect(props.domains.myTask);




    };


    _dateCellRenderer=(value)=>{
        const listData = this.getListData(value);
        let item_date=value.format("YYYY-MM-DD")

    return (
        <ul className="events calendarCell" >
            {listData.map((item,index) => {
                let type=item.type||'followup';
                let status='warning';
                let _message=(type==='todo'?item.task:item.remark);
                if(item.status==='done'){
                    status='success'
                }
                if(type==='followup' && item.status==='pending'){
                    status='processing'
                }
                return <li key={index}
                className='menu-item'
                style={{
                    paddingLeft:8,
                }}
                 onClick={(e)=>{
                    e.stopPropagation();
                    if(item.type==='todo'){
                        this.openTask(item)
                    }else{
                        this.openFollowUps(item)
                    }

                }}>
                    {/* <b>{item.message}</b> */}
                    <Tooltip title={_message}>
                    <Badge status={status}  text={_message}/>
                    </Tooltip>
                </li>
            }
            )}
            
        </ul>
    );
    }

    getListData=(value)=>{
        let pending_obj=this.state.pending_obj;
        let pending_todo_obj=this.state.pending_todo_obj;

        let listData=[];
        var currentDate=moment(value,"YYYY-MM-DD").format('YYYY-MM-DD');
        listData=pending_obj[currentDate]||[];
        let pendingTasks=pending_todo_obj[currentDate]||[];
        listData=listData.concat(pendingTasks)

        return listData;
        
    }

    _monthCellRenderer=(value)=>{
        const num = this.getMonthData(value);
        return num
            ? (
                <div   className="notes-month">
                    <section>{num}</section>
                    <span>Backlog number</span>
                </div>
            )
            : null;
    }

    getMonthData=(value)=>{
        if (value.month() === 8) {
            return 1394;
        }
    }

    openFollowUps=(data)=>{
        let type=data.status;
        this.setState({
            popup_detail_modal:true,
            current_selected_data:data
        })
    }

    openTask=(data)=>{
        let type=data.status;
        if(type==='done'){
            Modal.success({
                centered:true,
                maskClosable:true,
                title:data.task,
                content:(<div>
                    <p>{data.description}</p>
                    <br></br>
                </div>)
            })
        }else{
            Modal.confirm({
                maskClosable:true,
                title:data.task,
                centered:true,
                cancelText:"Delete",
                okText:"Mark Done",
                cancelButtonProps:{
                    onClick:()=>{
                        this.delete_todos.forId(data.id).execute();
                    }
                },
                okButtonProps:{
                    onClick:()=>{
                        this.mark_done_todo.forId(data.id).execute()
                        console.log("hello")
                    }
                },
                content:(<div>
                    <p>{data.description}</p>
                    <br></br>
                </div>)
            })
        }
    }

    render() {
        const {viewType,pending_list,pending_obj} = this.state;
        let list_followups_resp=this.list_followups.response();

        let post_resp=this.post_todos.response();
        return (
            <div>
                 <BasicHeader
      title="All Pending"
      no_back
      menu_items={dashboard_quick_menu}
      />
        <ErrorWrapper
        error={list_followups_resp}
        onReload={()=>{
            this.list_followups.execute();
        }}
        >
            <Spin spinning={list_followups_resp.fetching}>
            <div
            className='default-card'
                style={{
                height:'100vh',
                padding: 8
            }}>
                <Modal
                visible={this.state.popup_detail_modal}
                width={'90%'}
                destroyOnClose
                footer={null}
                className='transaction-modal'
                centered
                onCancel={()=>{
                    this.setState({
                        popup_detail_modal:false,
                        current_selected_data:null
                    })
                }}
                >
                    <ModalTransactionDetail 
                    onClose={()=>{
                        this.setState({
                            popup_detail_modal:false,
                            current_selected_data:null
                        })
                    }}
                    isModal={true}
                    match={{
                        params:{
                            transaction_id:this.state.current_selected_data&&this.state.current_selected_data.row_id
                        }
                    }}
                    remark={this.state.current_selected_data}
                    key={this.state.current_selected_data?`${this.state.current_selected_data.id}-${this.state.current_selected_data.status}`:null}
                    onDonePressed={(id)=>{
                        this.mark_done_followups.forId(id).execute();
                    }}

                    onRefreshList={()=>{
                        this.list_followups.execute()
                    }}
                    />
                </Modal>
                <PopUpForm 
                title="TO-DO"
                width="50%"
                forCreate={this.state.edit_id
                    ? false
                    : true}
                initialData={this.state.form_data||{}}
                fields={todo_field}
                open={this.state.modal_open}
                networkState={this.state.edit_id ? {} : post_resp}
                onClose={() => this.setState({ modal_open: false })}
                onSubmit={(data) => {
                    console.log("DATA", data);
                    this.post_todos.execute(data);
                    // this.handlePostPatch(data)
                    // this.post_rules.execute(data);
                }}
                />
                <Row type='flex' justify='end'>
                    
                </Row>
                <div style={{
                    paddingTop: 16
                }}>
                    {viewType === 'calendar'
                        ?<div> 
                            <Calendar 
                        // headerRender={()=>{
                        //    return <Title>All Pending Tasks</Title>
                        // }}
                        // defa
                        
                        // onSelect={(date)=>{
                        //     console.log("selected",date);
                        //     let item_date=date.format("YYYY-MM-DD")
                        //     this.setState({
                        //         modal_open:true,
                        //         form_data:{
                        //             date:item_date
                        //         }
                        //     })

                        // }}
                        onPanelChange={(date,mode)=>{
                            this.setState({
                                dateQuery:{
                                    month:date.get('month')+1,
                                    year:date.get('year')
                                }
                            },()=>{
                                // this.list_todos.config({
                                //     params:{
                                //         ...this.state.dateQuery
                                //     }
                                // }).execute();
                                this.list_followups.config({
                                    params:{
                                        ...this.state.dateQuery
                                    }
                                }).execute()
                            });
                            console.log("month",date.get('month'))
                            console.log("YEAR",date.get('year'));
                            
                        }}
                        mode='month'
                        className='pendingCalendar'
                        dateCellRender={this._dateCellRenderer} 
                        monthCellRender={this._monthCellRender}
                        />
                        </div>
                        : <div>
                            <List
                                // header={<Title>All Pending Tasks</Title>}
                                // footer={< div > Footer </div>}
                                // bordered
                                // style={{
                                //     textAlign:'left'
                                // }}
                                dataSource={pending_list}
                                renderItem={item => (
                                <List.Item>
                                    <List.Item.Meta
                                    title={<b>{item.message}</b>}
                                    description={item.date}
                                    />
                                </List.Item>
                            )}/>
                        </div>
}

                </div>

            </div>
            </Spin>
            </ErrorWrapper>
       </div>
        )
    }

    componentDidMount(){
        // this.list_todos.execute();
        this.list_followups.execute()
    }
}

export default withDomains(AllPending,"myTask")
